import { Pallet } from "../pallets.entity";
import { PalletsDTO } from "./pallets.dto";




export class PalletsAdapter {

    public convertDtoToEntity(details: PalletsDTO): Pallet {
        const pallets = new Pallet();
        if(details.palletId){
            pallets.palletId = details.palletId;
            pallets.updatedUser =details.updatedUser;
        }
        pallets.plantId = details.plantId;
        pallets.palletNo = details.palletNo;
        pallets.assocRfId = details.assocRfId;
        pallets.palletCode = details.palletCode;
        pallets.createdUser =details.createdUser;
        return pallets;
    }
    
}